const ENGLISH = 'en';
const ENGLISH_STR = 'English';
const SPANISH = 'es';
const SPANISH_STR = 'Spanish';

export type LANGUAGE_TYPE = 'en' | 'es';

export const languageTypes = {
    ENGLISH,
    ENGLISH_STR,
    SPANISH,
    SPANISH_STR
};
